import type { FeaturedCarouselTyped } from '@setplex/tria-api'
import type { Store } from 'effector'
import type { VodWithPrice } from '~/shared/interfaces'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { formatFeaturedRowVods } from '~/entities/movies/featured/lib'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $featuredCarouselTypeVodFormatted: Store<
  FeaturedCarouselTyped<VodWithPrice>[]
> = combine(
  api.banners.$featuredCarouselTypeVod,
  ssePurchasesModel.$vod,
  i18n.$t,
  (carousels, adjust) => {
    if (carousels?.length === 0) return []
    return carousels.map((category) => {
      return {
        ...category,
        content: formatFeaturedRowVods(category.content, adjust),
      } as FeaturedCarouselTyped<VodWithPrice>
    })
  }
)

export const $featuredCarouselVodTitle: Store<string> = combine(
  i18n.$t,
  ({ t }) => t('movies_featured')
)
